export const OPACITY_TRANSITION = 'opacity 200ms ease-in-out';
